export class Person {
    /**
     * constructor for person
     * @param {('MALE'|'FEMALE')} gender either male or female
     * @param {Number} age represents the age in years
     * @param {Number} weight represents the weight in kg
     * @param {Number} height represents the height in cm
     */
    constructor(gender, birthday, weight, height) {
        this.gender = gender
        this.birthday = birthday
        this.weight = weight
        this.height = height
    }

    /**
     * calculates the body mass index (bmi) of person by using the following term
     * weight/height²
     * @type {Number}
     */
    get bmi() {
        return (parseInt(this.weight)/(Math.pow((parseInt(this.height)/100), 2))).toFixed(1)
    }

    /**
     * calculates the age in years from the birthday date of the person
     */
    get age() {
        let birthdayEng = this.birthday.split('-')
        let finalDate = birthdayEng[1] + '.' + birthdayEng[2] + '.' + birthdayEng[0]
        return Math.floor((new Date().getTime() - new Date(finalDate).getTime()) / 31536000000)
    }

    /**
     * defines the factor to adjust for the calorie-calculations depending on sex
     */
    get genfactor() {
        return this.gender == 'MALE' ? 5 : -161
    }

}